import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
const debugMeta = document.querySelector('meta[name="stimulus-debug"]')?.content
application.debug = debugMeta === 'true'
window.Stimulus = application

export { application }
